"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("@ikea-aoa/utilities");
var exceptions_1 = require("@ikea-aoa/exceptions");
var CONNECTION_TIMEOUT = 15000;
/**
 * Service fetch utility.
 */
var IframeManager = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param url Iframe URL.
     * @param cacheStore Cache store.
     */
    function IframeManager(url, cacheStore) {
        if (cacheStore === void 0) { cacheStore = new utilities_1.GlobalCacheStore(); }
        this.url = null;
        this.cache = null;
        this.isConnected = false;
        this.url = url;
        this.cache = cacheStore.getStore('iframeManager');
    }
    /**
     * Connects the iframe.
     *
     * @returns Iframe.
     */
    IframeManager.prototype.getIframe = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var cacheItem = _this.cache.get(_this.url);
            if (cacheItem) {
                if (!_this.isConnected) {
                    cacheItem.connectedCount++;
                }
                if (cacheItem.error) {
                    reject(cacheItem.error);
                }
                else if (cacheItem.connectionTimeout === null) {
                    resolve(cacheItem.iframe);
                }
                else {
                    cacheItem.resolves.push(resolve);
                    cacheItem.rejects.push(reject);
                }
            }
            else {
                var iframe = document.createElement('iframe');
                var cacheItem_1 = {
                    connectedCount: 1,
                    iframe: iframe,
                    connectionTimeout: null,
                    resolves: [resolve],
                    rejects: [reject],
                    error: null
                };
                cacheItem_1.connectionTimeout = _this.getConnectionTimeout(cacheItem_1);
                _this.cache.set(_this.url, cacheItem_1);
                iframe.addEventListener('load', _this.onIframeLoad.bind(_this, cacheItem_1));
                iframe.src = _this.url;
                iframe.style.display = 'none';
                document.body.appendChild(iframe);
            }
            _this.isConnected = true;
        });
    };
    /**
     * Disconnects the iframe.
     */
    IframeManager.prototype.disconnect = function () {
        var cacheItem = this.cache.get(this.url);
        if (cacheItem) {
            cacheItem.connectedCount--;
            if (cacheItem.connectedCount === 0) {
                clearTimeout(cacheItem.connectionTimeout);
                document.body.removeChild(cacheItem.iframe);
                this.cache.delete(this.url);
            }
        }
        this.isConnected = false;
    };
    /**
     * Triggered on iframe load.
     *
     * @param cacheItem Cache item.
     */
    IframeManager.prototype.onIframeLoad = function (cacheItem) {
        clearTimeout(cacheItem.connectionTimeout);
        cacheItem.connectionTimeout = null;
        if (cacheItem.iframe.contentWindow) {
            var resolves = cacheItem.resolves;
            cacheItem.resolves = [];
            for (var _i = 0, resolves_1 = resolves; _i < resolves_1.length; _i++) {
                var resolve = resolves_1[_i];
                resolve(cacheItem.iframe);
            }
        }
        else {
            var rejects = cacheItem.rejects;
            cacheItem.error = new exceptions_1.ServiceException('Failed to load iframe. Missing access to iframe.contentWindow.');
            cacheItem.rejects = [];
            for (var _a = 0, rejects_1 = rejects; _a < rejects_1.length; _a++) {
                var reject = rejects_1[_a];
                reject(cacheItem.error);
            }
        }
    };
    /**
     * Returns a timeout.
     *
     * @param cacheItem Cache item.
     * @returns Timeout.
     */
    IframeManager.prototype.getConnectionTimeout = function (cacheItem) {
        return setTimeout(function () {
            var rejects = cacheItem.rejects;
            cacheItem.error = new exceptions_1.ServiceException('Failed to load iframe. Request timed out. Connection problems?');
            cacheItem.rejects = [];
            for (var _i = 0, rejects_2 = rejects; _i < rejects_2.length; _i++) {
                var reject = rejects_2[_i];
                reject(cacheItem.error);
            }
        }, CONNECTION_TIMEOUT);
    };
    return IframeManager;
}());
exports.default = IframeManager;
//# sourceMappingURL=IframeManager.js.map